import logo1 from "./Assets/images/new_logo.png"
import logo2 from "./Assets/images/Bitspilani25yearsLogo.png"
import logo3 from "./Assets/images/dubai-computer-science.png"
import logo4 from "./Assets/images/cous.jpg"

import photo1 from "./Assets/images/profile_photos/7.png"
import photo2 from "./Assets/images/profile_photos/sujala.png"
import photo3 from "./Assets/images/profile_photos/dir.png"
import photo4 from "./Assets/images/profile_photos/raja1.png"
import photo5 from "./Assets/images/profile_photos/pranav1.png"
import photo6 from "./Assets/images/profile_photos/tojo.png"
import photo7 from "./Assets/images/profile_photos/sapna.png"
import photo8 from "./Assets/images/profile_photos/Prof.WathiqMansoorUniversityofDubaiUAE.jpg"
import photo9 from "./Assets/images/profile_photos/Prof.AmjadGawanmehUniversityofDubaiUAE.jpg"
import photo10 from "./Assets/images/profile_photos/Dr.ShadiAtallaUniversityofDubaiUAE.jpg"
import photo11 from "./Assets/images/profile_photos/Prof.SiddharthaBhattacharyyaFloridaInstituteofTechnologyUSA.jpg"
import photo12 from "./Assets/images/profile_photos/Dr.NeeliPrasadTrustedMobiVehicleAvatarInc.USA.jpg"
import photo13 from "./Assets/images/IEEE Digital Privacy Logo.png"

import background_callforpaper from "./Assets/images/call_for_paper_wallpaper_2.jpg"

import icon1 from "./Assets/images/icons/intelligent_icon.png"
import icon2 from "./Assets/images/icons/iot_logo.png"
import icon3 from "./Assets/images/icons/security_icon.png"
import icon4 from "./Assets/images/icons/intelligent_system_logo.png"
import icon5 from "./Assets/images/icons/computing_logo.png"


import pdf1 from "./Assets/images/IEEE International Workshop on Digital Privacy for.pdf"
import pdf2 from "./Assets/images/Workshop on Robust FL on Edge Devices 2025.pdf"

import ieee_logo from "./Assets/images/ieee_logo.webp"

import arrow_down from "./Assets/images/arrow_down.png"

import springer_logo from "./Assets/images/springer_logo.png"
import cover1 from "./Assets/images/cins_2023_frontcover.png"

import speaker1 from "./Assets/images/profile_photos/ahcene_bounceur.png"
import speaker2 from "./Assets/images/profile_photos/NSR - Profile Pic 2025 - White Background.png"


export const LOGO_SRC = logo1
export const BITS_25_YEARS_LOGO = logo2
export const BITS_CS_LOGO = logo3
export const COMING_SOON = logo4
export const IEEE_LOGO = ieee_logo
export const SPRINGER_LOGO = springer_logo
export const IEEE_DP_LOGO = photo13

export const RAMGOPAL_PHOTO = photo1
export const SUJALA_PHOTO = photo2
export const DIRECTOR_PHOTO = photo3
export const RAJA_PHOTO = photo4
export const PRANAV_PHOTO = photo5
export const TOJO_PHOTO = photo6
export const SAPNA_PHOTO = photo7
export const WATHIQ_PHOTO = photo8
export const AMJAD_PHOTO = photo9
export const SHADI_PHOTO = photo10
export const SIDDHARTHA_PHOTO = photo11
export const NEELI_PHOTO = photo12
export const CALLFORPAPER_BACKGROUND = background_callforpaper
export const AHCENE_BOUNCER_PHOTO = speaker1
export const NS_RAJPUT_PHOTO = speaker2


export const SECURITY = icon3
export const IOT = icon2
export const INTELLIGENT_SYSTEMS = icon1
export const COMPUTING = icon5
export const OTHERS = icon4

export const PRIVACY = pdf1
export const FEDERATED = pdf2

export const ARROW_DOWN = arrow_down

export const CINS_2023_FRONTCOVER = cover1

export const CINS_2023_LINK = "https://link.springer.com/book/10.1007/978-3-031-48984-6#overview"
export const CINS_2024_LINK = "https://ieeexplore.ieee.org/xpl/conhome/10862984/proceeding"